import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import HomeWarrantyCenterWrapper from "@components/layouts/homewarrantycenterWrapper";
import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";
import colors from "@styles/variables/homewarrantycenterVariables.module.scss";

export default function HomeWarrantyCenterHome(): ReactElement {
    return (
        <HomeWarrantyCenterWrapper>
            <div className="bg-white">
                <ContactTop iconsFillColor={colors.iconColor} />
            </div>
            <FormSection iconsFillColor={colors.iconColor} />
        </HomeWarrantyCenterWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
